import {
  cloneDeep,
} from 'lodash';

import {
  importJsonData,
  initGetData,
} from '@/payloadTemplates';

const {
  templates,
  prefill = {},
} = importJsonData(
  require.context('./', false, /\.json$/),

  // It can be used in dev mode for prefilling fields
  // require.context('./prefill/', false, /\.json$/),
);

const getData = initGetData(templates, prefill);

export const cover = getData('cover');
export const yourDetails = getData('yourDetails');

export const QUOTE = {
  cover: cloneDeep(cover),
  yourDetails: cloneDeep(yourDetails),
};

export const getQuotePayload = config => {
  const payload = cloneDeep(QUOTE);
  payload.yourDetails.userKeepSignIn = !config.hiddenQuestions['user-keep-me-sign-in'];

  return payload;
};
